<template>
  <a-modal :visible="visible" :title="isEdit ? '编辑活动' : '新增活动'" okText="确认" cancelText="取消" :confirmLoading="loading" @ok="handleOk" @cancel="closeModal" :width="600">
    <a-form ref="formRef" :model="formState" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
      <a-form-item label="活动名称" required>
        <a-input v-model:value="formState.name" placeholder="请输入活动名称" />
      </a-form-item>

      <a-form-item label="页面路径" required>
        <a-input v-model:value="formState.value" placeholder="请输入跳转的页面路径" />
      </a-form-item>

      <a-form-item label="活动图片" required>
        <a-upload name="file" list-type="picture-card" class="avatar-uploader" :show-upload-list="false" :before-upload="beforeUpload" :custom-request="uploadImage">
          <img v-if="formState.imageUuid" :src="imageUrl + formState.imageUuid" alt="activity" style="width: 100%" />
          <div v-else>
            <plus-outlined v-if="!uploadLoading" />
            <loading-outlined v-else />
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        <div style="color: #999; font-size: 12px; margin-top: 8px;">只能上传 JPG/PNG 文件，建议尺寸: 750x300</div>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons-vue';
// 修改引入路径和方法名
import { AddActivity, UpdateActivity } from "@/api/shopping";
import { Upload } from "@/api/upload";

export default {
  name: "ShoppingActivityModal",
  components: {
    PlusOutlined,
    LoadingOutlined
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:visible', 'ok'],
  data() {
    return {
      loading: false,
      uploadLoading: false,
      imageUrl: '/api/file/img/',
      formState: {
        id: undefined,
        name: '',
        value: '',
        imageUuid: ''
      }
    };
  },
  computed: {
    isEdit() {
      return !!this.formState.id;
    }
  },
  watch: {
    record: {
      handler(val) {
        if (val && val.id) {
          this.formState = {
            id: val.id,
            name: val.name || '',
            value: val.value || '',
            imageUuid: val.imageUuid || ''
          };
        } else {
          this.resetForm();
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('只能上传 JPG/PNG 文件!');
      }
      return isJpgOrPng;
    },

    async uploadImage({ file, onSuccess, onError }) {
      this.uploadLoading = true;

      let formData = new FormData();
      formData.append('file', file);
      formData.append('category', 'portrait');
      formData.append('system', 'true');

      try {
        const res = await Upload(formData);

        if (res.errCode === 0 && res.data) {
          this.formState.imageUuid = res.data;
          this.$message.success('图片上传成功');
          onSuccess(res);
        } else {
          this.$message.error('上传失败：' + (res.message || '未知错误'));
          onError(new Error('Upload failed'));
        }
      } catch (error) {
        console.error("uploadImage error:", error);
        this.$message.error('网络错误，上传失败');
        onError(error);
      } finally {
        this.uploadLoading = false;
      }
    },

    async handleOk() {
      if (!this.formState.name || !this.formState.value || !this.formState.imageUuid) {
        this.$message.warning('请填写完整信息（名称、路径及图片）');
        return;
      }

      this.loading = true;
      try {
        let res;
        // 使用新的接口名称
        if (this.isEdit) {
          res = await UpdateActivity(this.formState);
        } else {
          res = await AddActivity(this.formState);
        }

        if (res.errCode === 0) {
          this.$message.success(this.isEdit ? '修改成功' : '新增成功');
          this.$emit('ok');
          this.closeModal();
        } else {
          this.$message.error(res.errMsg);
        }
      } catch (error) {
        console.error(error);
        this.$message.error('系统异常，请稍后重试');
      } finally {
        this.loading = false;
      }
    },

    closeModal() {
      this.$emit('update:visible', false);
      this.resetForm();
    },

    resetForm() {
      this.formState = {
        id: undefined,
        name: '',
        value: '',
        imageUuid: ''
      };
    }
  }
};
</script>

<style scoped>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
</style>